import QRCode from './components/QRCode.vue'

export default QRCode